(function () {
  angular
    .module("akitabox.main.menu", [
      "ngCookies",
      "angular-storage",
      "ui.router",
      "akitabox.core.services.flag",
      "akitabox.core.services.organization",
      "akitabox.core.services.identity",
      "akitabox.core.services.building",
      "akitabox.core.services.workOrder",
      "akitabox.core.services.qrcode",
      "akitabox.core.services.redirect",
      "akitabox.core.services.request",
      "akitabox.core.services.recent",
      "akitabox.core.services.shadow",
      "akitabox.core.services.user",
      "akitabox.core.toast",
      "akitabox.core.utils",
      "akitabox.mobile.constants",
      "akitabox.mobile.components.create-buttons",
      "akitabox.ui.dialogs.qrCode.pinSearch",
      "akitabox.ui.dialogs.qrCode.manualEntry",
      "akitabox.ui.dialogs.qrScanner",
    ])
    .controller("MainMenuController", MainMenuController);

  /** @ngInject */
  function MainMenuController(
    // Angular
    $q,
    $location,
    $window,
    // Third party
    $state,
    // Constants
    SERVICE_REQUEST_STATUS_NEW,
    // Services
    FeatureFlagService,
    OrganizationService,
    IdentityService,
    BuildingService,
    WorkOrderService,
    RedirectService,
    RequestService,
    ShadowService,
    ToastService,
    UserService
  ) {
    var self = this;

    var BUILDING_ERROR = "building";
    var WORK_ORDER_ERROR = "work_order";
    var REQUEST_ERROR = "request";

    var permissions = UserService.getPermissions();

    // Attributes
    self.user = UserService.getCurrent();
    self.organization = OrganizationService.getCurrent();
    self.buildingCount = 0;
    self.workOrderCount = 0;
    self.requestCount = 0;
    self.isLoading = true;
    self.createMenuOpen = false;
    self.countErrors = {};
    self.showAddButton = permissions.request.create || permissions.task.create;

    // Functions
    self.goToBuildings = goToBuildings;
    self.goToWorkOrderCreate = goToWorkOrderCreate;
    self.goToServiceRequestCreate = goToServiceRequestCreate;
    self.goToMyWorkOrders = goToMyWorkOrders;
    self.goToRequests = goToRequests;
    self.logout = logout;
    self.goToDesktop = goToDesktop;
    self.goToHelp = goToHelp;
    self.toggleCreateMenu = toggleCreateMenu;
    self.closeOverlay = closeOverlay;

    init();

    function init() {
      getCounts();
    }

    function getCounts() {
      var countRequests = [getBuildingCount()];

      if (self.organization && self.organization.show_tasks) {
        countRequests.push(getWorkOrderCount());
        countRequests.push(getRequestCount());
      }

      $q.all(countRequests).then(function () {
        self.isLoading = false;
      });
    }

    function getBuildingCount() {
      var params = {
        count: true,
      };

      return BuildingService.getByOrganization(self.organization._id, params)
        .then(function (result) {
          self.buildingCount = result.count;
        })
        .catch(function (err) {
          onCountError(BUILDING_ERROR, err);
        });
    }

    function toggleCreateMenu() {
      self.createMenuOpen = !self.createMenuOpen;
    }

    function closeOverlay() {
      self.toggleCreateMenu();
    }

    function getWorkOrderCount() {
      var params = {
        count: true,
        status: "open",
        assignee_users: "$in," + self.user._id,
      };

      return WorkOrderService.getByOrganization(self.organization._id, params)
        .then(function (result) {
          self.workOrderCount = result.count;
        })
        .catch(function (err) {
          onCountError(WORK_ORDER_ERROR, err);
        });
    }

    function getRequestCount() {
      var params = {
        count: true,
        status: SERVICE_REQUEST_STATUS_NEW,
      };
      return RequestService.getByOrganization(self.organization._id, params)
        .then(function (result) {
          self.requestCount = result.count;
        })
        .catch(function (err) {
          onCountError(REQUEST_ERROR, err);
        });
    }

    function onCountError(type, err) {
      self.countErrors[type] = err;
      ToastService.showError(err);
      return;
    }

    function goToBuildings() {
      $state.go("app.buildings", { q: null }, { reload: true });
    }

    function goToRequests() {
      $state.go("app.serviceRequests.new");
    }

    function goToWorkOrderCreate() {
      // Send a create-workorder GA event.
      ShadowService.sendEvent("workorder", "create-workorder");

      $state.go("app.workOrders.create");
    }

    function goToServiceRequestCreate() {
      $state.go("app.serviceRequests.create");
    }

    function goToMyWorkOrders() {
      $state.go(
        "app.workOrders.my",
        {
          status: "open",
        },
        {
          reload: true,
        }
      );
    }

    function logout() {
      $state.go("auth.logout");
    }

    function goToDesktop() {
      RedirectService.redirectToDesktop($location.path());
    }

    function goToHelp() {
      $window.location.href = "https://akitabox.zendesk.com";
    }
  }
})();
